module.exports = __webpack_public_path__ + "static/media/slider-small-2.68fb79ca.jpg";